<div class="row mx-0 justify-content-center align-items-center footer">
    &#169; Integrated Regulatory Reporting
</div>
